/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UtilizationResourceAggregationResponse {
    getFixupPrototypeFunction() { return UtilizationResourceAggregationResponse.fixupPrototype; }

    static newInstance(model: Partial<UtilizationResourceAggregationResponse>): UtilizationResourceAggregationResponse {
        let obj = Object.assign(new UtilizationResourceAggregationResponse(), model);
        UtilizationResourceAggregationResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UtilizationResourceAggregationResponse>): UtilizationResourceAggregationResponse {
        if (!model) return null;
        return UtilizationResourceAggregationResponse.newInstance(<UtilizationResourceAggregationResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UtilizationResourceAggregationResponse) {
        if (!obj) return;

        models.UtilizationResourceAggregationResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UtilizationResourceAggregationResponse): boolean {
        Object.setPrototypeOf(obj, UtilizationResourceAggregationResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metrics) {
            for (let val of this.metrics) {
                models.ResourceUtilizationMetric.fixupPrototype(val);
            }
        }
    }

    /**
     * List of supported hourly aggregation types (e.g., avg, min, max) for utilization metrics
     */
    hourly_aggregations: Array<string>;

    /**
     * List of supported daily aggregation types (e.g., avg, min, max) for utilization metrics
     */
    daily_aggregations: Array<string>;

    /**
     * Time-based aggregation levels available for utilization data (hourly, daily)
     */
    time_aggregation: Array<string>;

    /**
     * List of utilization metrics and their supported aggregation configurations
     */
    metrics: Array<models.ResourceUtilizationMetric>;

}
